import type { AxiosError } from 'axios';
import { unfoldError } from '@/common/js/notice';
import { TIMEOUT_CODE } from '../error';
import { HttpClient } from '../client';
import { IRequestConfig } from '../interface';

let plugin: Retry;
export class Retry {

    private readonly _httpClient: HttpClient;

    private readonly _retry: number;

    private readonly _retryDelay: number;

    public constructor( httpClient: HttpClient ) {

        this._httpClient = httpClient;
        this._retry = 4;
        this._retryDelay = 1000;

    }

    /**
     *
     * @param {import('axios').AxiosError} err
     * @returns
     */
    public async responseOnError( err: AxiosError ): Promise<any> {

        if ( !err.response && err.code === TIMEOUT_CODE ) {

            // 处理超时的情况
            const config = err.config as IRequestConfig;

            // If config does not exist or the retry option is not set, reject
            if ( !config || !this._retry ) return Promise.reject( err );

            // Set the variable for keeping track of the retry count
            config.retryCount = config.retryCount ?? 0;

            // Check if we've maxed out the total number of retries
            if ( config.retryCount >= this._retry ) {

                unfoldError( 'errors.network_error', 30000 );
                // Reject with the error
                return Promise.reject( err );

            }

            // Increase the retry count
            config.retryCount += 1;

            // Create new promise to handle exponential backoff
            const backoff = new Promise(( resolve ) => {

                setTimeout( function() {

                    resolve( true );

                }, this._retryDelay || 1 );

            });

            // Return the promise in which recalls axios to retry the request
            return backoff.then((): any => {

                return this._httpClient.httpRequest({
                    method: config.method!.toUpperCase(),
                    url: config.url!,
                    data: config.data,
                    config
                });

            });

        }

        return Promise.reject( err );

    }

    public static register( httpClient: HttpClient ): void {

        if ( !plugin ) {

            plugin = new Retry( httpClient );

        }
        httpClient._client.interceptors.response.use(
            undefined,
            plugin.responseOnError.bind( plugin )
        );

    }

}
